<template>
  <div class="hello">
    <div class="subTitle">周口天立小初学校</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'zktlxcxx',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM4f1ulwiRmGOUf7FH05Ffz0nzRSY/RNT0paMkkBoNt/ryPkfDZmFZVeaZRqZcxr7A+WHVX3J2MFeZ/JHTAjfaBD8S6/NzIMLGEv1FOU45wVHoABm8W7MVpdlIrPTN2Ea7gUUhreokb7fcYdVfTcsZVg='
        },
        {
          label: '餐费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM48+v9yejigm377Keq2XZXtXkMuWCbuSxub8xMoQ4mtc6Eg7I55WCKoi/TnRSPelGzsMOpi01ml5Zn6RuuorpR8blgELeWdngSRlhS0yPacIiXQHGdutcHjNOI2CdU970VLCJaLED9aKJafZmN97du4='
        },
        {
          label: '素养服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM5ldZeFQifLiWeiJrTJH7S5oeKTHrRztFi9CQfwro0N+0XZgHlD4lJfop+sGZCtSk7LZhLoEznlqY+4rFZ0gVH2N3fQHytDoTLFnp+gqiuSIplEsyQeN8SCH+6/Vookuky8toWQHuXy4UzvKr0nfXCWGSZQ4fdun8rZpgr/VpU0W'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM2MVCP+3i2o62dKyAyvTUOGfyGfO1PplN6gkIH5lgsNUq/b2TbgOHh0SMjxwzo9L9885idQJMSoOHMfqTJaYZIr0ErMDimgAVj0d9dDfnCRFtmppCUZu8iKvUWkvZgchZfbQ/FFEWxXtgFZrPMR4ODw='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '周口天立小初学校';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

